import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeoplemin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#9A6767",
			d: "M13.216 8.496h-1.134c.116.317.179.658.179 1.014v4.287c0 .149-.026.291-.073.424h1.875c.7 0 1.27-.57 1.27-1.27v-2.338a2.12 2.12 0 0 0-2.117-2.117Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4D5BD8",
			d: "M3.74 9.51c0-.356.063-.697.178-1.014H2.784a2.12 2.12 0 0 0-2.117 2.117v2.337c0 .7.57 1.27 1.27 1.27h1.875a1.265 1.265 0 0 1-.073-.423V9.51Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#A9B3BC",
			d: "M9.297 7.393H6.704A2.12 2.12 0 0 0 4.586 9.51v4.287c0 .234.19.424.424.424h5.98c.234 0 .424-.19.424-.424V9.51a2.12 2.12 0 0 0-2.117-2.117ZM8 1.78a2.55 2.55 0 0 0-2.546 2.546 2.548 2.548 0 0 0 3.79 2.22 2.548 2.548 0 0 0 1.302-2.22A2.55 2.55 0 0 0 8 1.779Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4D5BD8",
			d: "M3.529 4.153c-1.05 0-1.904.854-1.904 1.904a1.906 1.906 0 0 0 2.654 1.75c.399-.172.727-.475.93-.856a1.906 1.906 0 0 0-1.68-2.799Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#9A6767",
			d: "M12.471 4.153a1.906 1.906 0 0 0-1.68 2.798 1.916 1.916 0 0 0 1.68 1.01c1.05 0 1.904-.854 1.904-1.904 0-1.05-.854-1.904-1.904-1.904Z"
		})
	]
});
const ForwardRef = forwardRef(SvgPeoplemin);
export { ForwardRef as ReactComponent };
